<div class="title">
  <div class="text-title">
    <div id="titre">
      <div>
        <div><b>Espace client</b></div>
        <div id="etoiles">
          <img src="/assets/pictogrammes/etoiles.svg" />
        </div>
      </div>
    </div>
    <div id="subtitle">
      <div>
        <div>Connectez-vous à votre espace client</div>
        <div id="globe">
          <img src="/assets/pictogrammes/globe.svg" />
        </div>
      </div>
    </div>
  </div>
  <div class="wave">
    <img src="/assets/img/wave.svg" />
  </div>
</div>


<div class="page">
  <h1>Formulaire de réinitialisation<br /> <span class="color-title">de mot de passe</span></h1>
  <div class="form">
    <div class="icon-connexion">
      <img src="/assets/pictogrammes/login.svg" />
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="form-connexion" autocomplete="off">
      <mat-card class="mat-elevation-z">
        <mat-form-field>
          <mat-label>Nouveau mot de passe</mat-label>
          <input required mat-input matInput [type]="getFormType('firstPassword')" formControlName="password"
            placeholder="Votre nouveau mot de passe" (keyup)="isValidPassword($event)" autocomplete="off">
          <mat-icon matSuffix (click)="toggleVisibility('firstPassword')">
            {{isVisible('firstPassword') ? 'visibility_off' : 'visibility'}}
          </mat-icon>
          <mat-error *ngIf="form.hasError('required',['password'])">Le mot de passe est requis</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Confirmation du nouveau mot de passe</mat-label>
          <input matInput [type]="getFormType('secondPassword')" formControlName="confirmPassword"
            placeholder="Veuillez répéter le nouveau mot de passe" appConfirmPasswordValidator="password" autocomplete="off">
          <mat-icon matSuffix (click)="toggleVisibility('secondPassword')">
            {{isVisible('secondPassword') ? 'visibility_off' : 'visibility'}}
          </mat-icon>
          <mat-error *ngIf="!form.hasError('required',['confirmPassword']) && form.hasError('sameAsControl',['confirmPassword'])">
            Les mots de passe sont différents
          </mat-error>
          <mat-error *ngIf="form.hasError('required',['confirmPassword'])">La confirmation du mot de passe est requise</mat-error>
        </mat-form-field>

        <p>Le nouveau mot de passe doit respecter les critères suivants :</p>
        <span>
          <mat-icon *ngIf="isSize" color="primary" inline="true">done</mat-icon>
          <mat-icon *ngIf="!isSize" color="red" inline="true">clear</mat-icon>
          8 caractères minimum
        </span>
        <span>
          <mat-icon *ngIf="isMaj" color="primary" inline="true">done</mat-icon>
          <mat-icon *ngIf="!isMaj" color="red" inline="true">clear</mat-icon>
          Au moins 1 lettre majuscule A-Z
        </span>
        <span>
          <mat-icon *ngIf="isMin" color="primary" inline="true">done</mat-icon>
          <mat-icon *ngIf="!isMin" color="red" inline="true">clear</mat-icon>
          Au moins 1 lettre minuscule a-z
        </span>
        <span>
          <mat-icon *ngIf="isNum" color="primary" inline="true">done</mat-icon>
          <mat-icon *ngIf="!isNum" color="red" inline="true">clear</mat-icon>
          Au moins 1 chiffre de 0 à 9
        </span>
        <span>
          <mat-icon *ngIf="isSpecial" color="primary" inline="true">done</mat-icon>
          <mat-icon *ngIf="!isSpecial" color="red" inline="true">clear</mat-icon>
          Au moins 1 caractère spécial (!, $, #, %, &#64;, etc.)
        </span>
        <span>
          <mat-icon *ngIf="isNotLogin" color="primary" inline="true">done</mat-icon>
          <mat-icon *ngIf="!isNotLogin" color="red" inline="true">clear</mat-icon>
          Différent de l'identifiant
        </span>

        <p *ngIf="form.hasError('unauthorized')">
          Erreur d'identifiant ou de mot de passe
        </p>

        <button type="submit" mat-raised-button color="primary" class="btn">Enregistrer</button>
        <a routerLink="/login" class="link">> S'identifier</a>
      </mat-card>
    </form>
  </div>
</div>